import { render, staticRenderFns } from "./PayerTable.vue?vue&type=template&id=72991b19&"
import script from "./PayerTable.vue?vue&type=script&lang=js&"
export * from "./PayerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports